import { unauthenticatedFetch } from '../../api/request';

export const FEATURES = {
    WEB_COACH_SMS_CHECKBOX_V1: 'web_coach_sms_checkbox_v1'
};

export default function getPublicFeatures() {
    return unauthenticatedFetch('/public/v5/features');
}
